var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17.163,
  height: 41,
  viewBox: "0 0 17.163 41"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2456"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 64",
  d: "M16.247 19.4L2.532.932A.95.95 0 00.916.97a1.942 1.942 0 000 2.139l12.907 17.382L.916 37.873a1.937 1.937 0 000 2.176.95.95 0 001.616 0l13.715-18.47a1.937 1.937 0 000-2.179z",
  fill: "#fff",
  stroke: "#fff"
}))));
export default __webpack_public_path__ + "static/media/nextimage.e84973f9.svg";
export { SvgComponent as ReactComponent };